// extracted by mini-css-extract-plugin
module.exports = {"link":"_3ri1I","container":"u8IuZ","contentPreview":"_3bOMr","image":"_3spfq","contentBlock":"_13gqo","title":"NXm75","numbersSeparator":"_3SDPO","categoryBadgeWrapper":"_21EwJ"};